import React, {Fragment} from 'react';
import createEditor, {referenceActionData} from '../form/ComponentEditor';
import Box from '../layout/Box';
import DiscountForm from './forms/DiscountForm';
import DiscountList from './lists/DiscountList';
import classNames from 'classnames';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";
import {isTrue} from "../../utils/other";
import {get} from "../../utils/dotutils";
import {isset} from "locutus/php/var";

class DiscountEditor extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            editorHeader: this.props.values.name || "Új kedvezmény felvitele"
        }
    }

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.setState({editorHeader: data.name});
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.setState({editorHeader: "Új kedvezmény felvitele"});
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        return (
            <Fragment>
                <List
                    {...this.props}
                    header={"Kedvezmények"}
                    theme="default"
                    footer={[
                        <Button key="0" type="button" color="default" disabled={this.props.isLoading} onClick={ this.pristineForm }>
                            Új
                        </Button>
                    ]}
                >
                    <DiscountList ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />
                </List>
                <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header={this.state.editorHeader}
                    footer={[
                        <Button key="0" type="button" disabled={ !this.props.dirty || this.props.isLoading } color="primary" className="pull-right" onClick={ this.saveForm }>
                            Mentés
                        </Button>,
                        <Button key="1" disabled={!this.props.values[this.props.componentConfig.idfield]}
                                color="danger"
                                className="pull-left"
                                onClick={this.props.deleteForm}>
                            Törlés
                        </Button>
                    ]}
                >
                    <DiscountForm {...this.props} />
                </Editor>
            </Fragment>
        );
    }
}

export default createEditor({componentName: "Discount", WrappedComponent: DiscountEditor, props: {
    view: "admin",
    componentActions: async (action, data, params, componentConfig) => {
        data = await referenceActionData(data, componentConfig);
        if (data.calculation_strategy === "one_of_each") {
            data.condition_qty = data.condition_qty || 1;
        } else if ((data.conditions || []).length > 1) {
            data.conditions = [data.conditions[0]];
        }
        data.sametarget = isTrue(data.sametarget);
        const filterValidator = (filter) => {
            if (Array.isArray(filter)) {
                if (!filter.length) return false;
                return !filter.some((filter) => {
                    return !filterValidator(filter);
                });
            } else if (isset(filter.filters)) {
                return filterValidator(filter.filters);
            } else {
                return (filter.field && filter.operator && filter.value);
            }
        }
        if (data.type === "cartdiscount") {
            data.conditions = [];
            data.targets = [];
        } else {
            if (data.type === "groupdiscount") {
                if (!data.sametarget) {
                    if (!(data?.conditions?.length || 0)) {
                        throw new Error("Nincsenek feltételek kiválasztva, vagy nincs bepipálva a 'Feltétel szűrés megegyezik a cél szűréssel'!");
                    }
                    if (!filterValidator((data?.conditions || []).map(c => c.filter))) {
                        throw new Error("Hibás feltétel szűrő!");
                    }
                } else {
                    data.conditions = [];
                }
            } else {
                data.conditions = [];
            }
            if (!(data?.targets?.length || 0)) {
                throw new Error("Üres a kedvezmény cél szűrése!");
            }
            if (!filterValidator((data?.targets || []).map(c => c.filter))) {
                throw new Error("Hibás cél szűrő!");
            }
        }
        if (data.type === "packagediscount") {
            data.exclusions = [];
            if (!(data.targets || []).length) {
                throw new Error("Üres a kedvezmény cél szűrése!");
            }
            if ((data.targets || []).length > 1) {
                throw new Error("Túl sok cél van kiválasztva!");
            }
            (data.targets || []).map((target) => {
                if (!(get(target, "filter.filters") || []).length) {
                    throw new Error(" Üres a kedvezmény cél szűrése!");
                }
                if ((get(target, "filter.filters") || []).length > 1) {
                    throw new Error("Túl sok cél van kiválasztva!");
                }
                if ((get(target, "filter.filters") || [])[0].field !== "id") {
                    throw new Error("Nem kiadások vannak kiválasztva!");
                }
                if ((get(target, "filter.filters") || [])[0].operator !== "in") {
                    throw new Error("Nem kiadás lista vannak kiválasztva!");
                }
                if (!((get(target, "filter.filters") || [])[0].value || []).length) {
                    throw new Error("Nincsenek kiadások kiválasztva!");
                }
            });
        }

        return {action,data};
    }
}});
